export default {"src":"/_next/static/media/nftfy.348b95c3.svg","height":32,"width":32};